var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.7,
    height: 19.7,
    viewBox: "0 0 23.7 19.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(-0.15 -2.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2718",
    "data-name": "Group 2718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M17,21.85a.85.85,0,0,1-.85-.85V19A3.154,3.154,0,0,0,13,15.85H5A3.154,3.154,0,0,0,1.85,19v2a.85.85,0,1,1-1.7,0V19A4.855,4.855,0,0,1,5,14.15h8A4.855,4.855,0,0,1,17.85,19v2A.85.85,0,0,1,17,21.85Z",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    d: "M4-.85A4.85,4.85,0,1,1-.85,4,4.855,4.855,0,0,1,4-.85Zm0,8A3.15,3.15,0,1,0,.85,4,3.154,3.154,0,0,0,4,7.15Z",
    transform: "translate(5 3)",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M23,21.85a.85.85,0,0,1-.85-.85V19a3.15,3.15,0,0,0-2.362-3.047.85.85,0,0,1,.425-1.646A4.85,4.85,0,0,1,23.85,19v2A.85.85,0,0,1,23,21.85Z",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M16,11.73a.85.85,0,0,1-.21-1.674,3.15,3.15,0,0,0,0-6.1.85.85,0,0,1,.422-1.647,4.85,4.85,0,0,1,0,9.4A.852.852,0,0,1,16,11.73Z",
    fill: "#95a7c6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.9dd54f08358a68e031ef88e70b077fea.svg";
export { ForwardRef as ReactComponent };